import { useEffect } from "react";
import ReactGA from "react-ga";
import TermsOfServicePage from "../components/pages/Terms";
import { pageview } from "../lib/fpixel";

const TermsOfService = (): JSX.Element => {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
    pageview(); // fbpixel page view
  }, []);

  return <TermsOfServicePage />;
};

export default TermsOfService;
